import "./map.scss";
import dynamic from 'next/dynamic';
const MapComponent = dynamic(() => import('../elements/map'), { ssr: false, loading: () => null });

export default ({location, infoBig, infoSmall}) => (
  <div className="article-map">
    <div className="info">
      <div className="big">{infoBig}</div>
      <div className="small">{infoSmall}</div>
    </div>
    <div className="map">
      <MapComponent locations={[location]} />
    </div>
  </div>
);
